import { Diagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/Diagram';
import { DiagramBox } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramBox';
import { DiagramText } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramText';
import { BoxTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/BoxTone';
import { TextTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/TextTone';

export const RankingPriorityLenderDiagram = () => (
  <Diagram viewBox="0 0 300 110">
    <DiagramBox x={8} y={26} width={96} height={32} tone={BoxTone.HIGHLIGHT} />
    <DiagramText x={56} y={46} bold>
      ★ Lender C
    </DiagramText>
    <DiagramText x={8} y={76} tone={TextTone.MUTED} small anchor="start" tId="ALWAYS_FIRST" />
    {['A', 'B', 'D'].map((label, index) => (
      <g key={label}>
        <DiagramBox x={122 + index * 58} y={29} width={48} />
        <DiagramText x={146 + index * 58} y={46}>
          {label}
        </DiagramText>
      </g>
    ))}
    <DiagramText x={292} y={76} tone={TextTone.MUTED} small anchor="end" tId="REST_BY_PRICE" />
    <DiagramText x={150} y={100} tone={TextTone.MUTED} small tId="NO_PRICING_FALLBACK" />
  </Diagram>
);
